import React, { useEffect, useRef, useState } from 'react';

import UseStyle from "../useStyles";

import Modal from '../../shared/form/modal';

import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import { MenuItem } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';

import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const ReunioesUserTable = (props) => {

  const classes = UseStyle();

  const {
    type = 'column',
    user,
    editHandle,
    lugar,
    opcoes,
    isVisualizar,
    handleRemove
  } = props;

  const [modal, setModal] = useState(false);
  const [convidado, setConvidado] = useState();

  const switchDisplay = (type) => {
    if (type) {
      switch (type) {
        case 'right':
          return 'row-reverse'
        case 'left':
          return 'row'
        default:
          return 'column-reverse';
      }
    }
  }

  const alterarUsuario = () => {
    if (!convidado) {
      return;
    }
    editHandle('cadeira' + lugar, convidado);
    setModal(false);
  }

  const switchAlign = (type) => {
    if (type) {
      switch (type) {
        case 'right':
          return 'flex-end'
        case 'left':
          return 'flex-start'
        default:
          return 'center';
      }
    }
  }

  const cancelButton = <Button onClick={() => setModal(false)} variant="outlined">Cancelar</Button>;
  const confirmButton = <Button onClick={() => alterarUsuario()} variant="contained" color='primary'>Confirmar edição</Button>;

  const handleShowActive = (usuario) => {
    return (usuario?.usuarioPerfil?.ativo || usuario?.ativo) || !usuario;
  }

  return (
    <>
      <Hidden xsDown>
        <div style={{ display: 'flex', flexDirection: switchDisplay(type), alignItems: switchAlign(type), marginTop: 10 }}>
          <div style={{ margin: 5 }} className={user ? classes.imagemReplaceFotoExtraSmall : classes.imagemReplaceFotoExtraSmallGray}>
            {user ? user.usuarioPerfil.nomeUsuario.substring(0, 2).toUpperCase() : <PersonOutlineIcon />}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: switchAlign(type) }}>
            <p className={classes.mesaNomeUser} style={{ margin: 0, padding: 0 }}>{(user && user.usuarioPerfil) ? user.usuarioPerfil.nomeUsuario : 'Nome'}</p>
            <p className={classes.mesaInfoUser} style={{ margin: 0, padding: 0, textAlign: type === 'right' ? 'right' : 'left' }}>{(user && user.usuarioPerfil) ? user.usuarioPerfil.descricaoTipoPerfil : 'Perfil'} {(user && user.usuarioPerfil) ? user.usuarioPerfil.conselheiroPerfil.descricaoTitularidade : 'titularidade'}</p>
            <p className={classes.mesaInfoUser} style={{ margin: 0, padding: 0 }}>{(user && user.usuarioPerfil) ? user.usuarioPerfil.siglaEntidade : 'entidade'}</p>
            {!isVisualizar &&
              <div style={{ display: 'flex', gap: 2 }}>
                <a onClick={() => handleShowActive(user) ? setModal(true) : undefined} className={classes.mesaLinkUser} style={{ margin: 0, padding: 0, color: handleShowActive(user) ? undefined : '#808080' }}>Editar</a>
                {user && <a className={classes.mesaLinkUser} onClick={() => handleShowActive(user) ? handleRemove(user, lugar) : undefined} style={{ color: handleShowActive(user) ? undefined : '#808080' }}>| Remover</a>}
              </div>
            }
          </div>
        </div>
      </Hidden>
      <Hidden smUp>
        <div style={{ display: 'flex', flexDirection: "column", alignItems: 'center', marginTop: 10 }}>
          <div style={{ margin: 5 }} className={user ? classes.imagemReplaceFotoExtraSmall : classes.imagemReplaceFotoExtraSmallGray}>
            {user ? user.usuarioPerfil.nomeUsuario.substring(0, 2).toUpperCase() : <PersonOutlineIcon />}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <p className={classes.mesaNomeUser} style={{ margin: 0, padding: 0 }}>{(user && user.usuarioPerfil) ? user.usuarioPerfil.nomeUsuario : 'Nome'}</p>
            <p className={classes.mesaInfoUser} style={{ margin: 0, padding: 0, textAlign: 'center' }}>{(user && user.usuarioPerfil) ? user.usuarioPerfil.descricaoTipoPerfil : 'Perfil'} {(user && user.usuarioPerfil) ? user.usuarioPerfil.conselheiroPerfil.descricaoTitularidade : 'titularidade'}</p>
            <p className={classes.mesaInfoUser} style={{ margin: 0, padding: 0 }}>{(user && user.usuarioPerfil) ? user.usuarioPerfil.siglaEntidade : 'entidade'}</p>
            {!isVisualizar &&
              <div style={{ display: 'flex', gap: 2 }}>
                <a onClick={() => handleShowActive(user) ? setModal(true) : undefined} className={classes.mesaLinkUser} style={{ margin: 0, padding: 0, color: handleShowActive(user) ? undefined : '#808080' }}>Editar</a>
                {user && <a className={classes.mesaLinkUser} onClick={() => handleShowActive(user) ? handleRemove(user, lugar) : undefined} style={{ color: handleShowActive(user) ? undefined : '#808080' }}>| Remover</a>}
              </div>
            }
          </div>
        </div>
      </Hidden>
      <Modal open={modal} onClose={() => setModal(false)} CancelButton={cancelButton} ConfirmButton={confirmButton} title="editar lugar">
        <Select value={convidado}
          onChange={(e) => setConvidado(e.target.value)}
          fullWidth
          displayEmpty
          variant="outlined"
          IconComponent={ExpandMoreIcon}
          disableUnderline
          placeholder="selecione o convidado"
        >
          <MenuItem selected value="">Selecione o convidado</MenuItem>
          {!isVisualizar && opcoes.map((item, key) => {
            return (
              <MenuItem key={key} value={item}>{item.usuarioPerfil ? item.usuarioPerfil.nomeUsuario : item.nome}</MenuItem>
            );
          })}
        </Select>
      </Modal>
    </>
  );
}

export default ReunioesUserTable;
